import { httpApi } from '@app/api/http.api';

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
  // totalPage?: number;
}

//===========================================================================

export const getSetting = (factory?: string): Promise<any> =>
  httpApi
    .get<any>((factory ? factory : window.location.pathname.split('/')[1]) + '/api/gemba/v0/setting/info')
    .then(({ data }) => data);

export const editSetting = (req: any): Promise<any> =>
  httpApi
    .put<any>(window.location.pathname.split('/')[1] + '/api/gemba/v0/setting/update', { ...req })
    .then(({ data }) => data);
